import React from "react";
import { useHistory } from "react-router-dom";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { IPayerResponse } from "@wingspanhq/payments/dist/interfaces";
import { useRequirementsConfig } from "../../../../Requirements/useRequirementsConfig";
import { RequirementContextType } from "../../../../Requirements/types";
import { RequirementDetailsContent } from "../../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { useHistoryCheckpoint } from "../../../../../shared/hooks/useHistoryCheckpoint";
import { DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH } from "./index";

type RequirementsDetailsProps = {
  payer: IPayerResponse;
  requirement: IRequirementResponse;
};

export const PayerRequirementDetails: React.FC<RequirementsDetailsProps> = ({
  payer,
  requirement
}) => {
  const history = useHistory();

  const historyCheckpoint = useHistoryCheckpoint(
    DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH
  );

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payer
  });

  const title =
    requirementConfig.getRequirementName(requirement) || "Requirement";

  const headerActions = requirementConfig.getOnboardingToolbarActions(
    requirement
  )?.(() => {
    if (historyCheckpoint.isCheckpointSaved()) {
      historyCheckpoint.goToCheckpoint();
    } else {
      history.goBack();
    }
  });

  return (
    <>
      <WSPageToolbar title={title} actions={headerActions} />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payer}
        requirement={requirement}
        showTitle={false}
      />
    </>
  );
};
